// extracted by mini-css-extract-plugin
export default {"CollapseHeader":"FilterSideBarLight__CollapseHeader___nXvc0","ExpansionPanelTitle":"FilterSideBarLight__ExpansionPanelTitle___DPnOj"};